
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-width":"2","transform":"translate(3 13)"}},[_c('path',{attrs:{"stroke":"#E9ECED","stroke-linecap":"round","d":"M47.472 15.13h9.638M47.472.904h9.638M.273 15.303h14.242M.273 1h14.242"}}),_c('path',{attrs:{"fill":"#FFF","stroke":"#D6DBEA","d":"M47.739 39.969V1H14.853v38.784"}}),_c('path',{attrs:{"fill":"#FFF","stroke":"#E9ECED","d":"M2.32 39.904V27.317c0-.632.4-1.144.894-1.144h5.365c.494 0 .894.512.894 1.144v12.294"}}),_c('path',{attrs:{"fill":"#FFF","stroke":"#D6DBEA","stroke-linecap":"round","stroke-linejoin":"round","d":"M33.918 35.376V24.164h7.458v11.164"}}),_c('path',{attrs:{"stroke":"#D6DBEA","d":"M31.452 39.552v-2.624a1 1 0 011-1h10.39a1 1 0 011 1v2.624h0"}}),_c('rect',{attrs:{"width":"7.154","height":"7.154","x":"20.627","y":"20.308","fill":"#FFF","stroke":"#D6DBEA","rx":"1.144"}}),_c('path',{attrs:{"stroke":"#D6DBEA","stroke-linecap":"round","d":"M.273 39.969l56.837-.065"}}),_c('path',{attrs:{"stroke":"#D6DBEA","stroke-linecap":"square","d":"M15.833 15.13h30.75"}}),_c('path',{attrs:{"stroke":"#E9ECED","stroke-linecap":"round","d":"M56.994 20.453H53.98a.25.25 0 00-.25.25v6.502c0 .138.112.25.25.25h3.015"}})])])
          )
        }
      }
    